
//20
Object.defineProperty(exports, "__esModule", { value: true });
require("../../common/a11y.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "FilePickerButton211755798",
    {"root":"FilePickerButton211755798--root","fileInput":"FilePickerButton211755798--fileInput","chooseFileButton":"FilePickerButton211755798--chooseFileButton"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/file-picker-button/FilePickerButton.st.css
// module id = 1296
// module chunks = 0